import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import _noop from 'lodash/noop';

import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts.ts';
import Headshot from '@mlb/react-patterns/components/Headshot/headshot.tsx';

import { mainCq } from 'bdvp-common/src/styles/helpers/main-cq';

import { Tracking } from 'bdvp-tracking';

export const Wrapper = styled.div`
    display: flex;
    flex: 1 1 auto;
    font-size: 13px;
`;

const Info = styled.div`
    display: flex;
    flex: 0 0 50%;
    font-family: ${FONTS.primaryFont};
    padding-right: 1%;
    text-transform: uppercase;
    ${mainCq.md`
        flex-basis: auto;
        padding-right: 4%;
    `}
    ${mainCq.xl`
        padding-right: 6%;
    `}
`;

const Label = styled.div`
    color: ${COLORS.mlbGrey3};
    font-family: ${FONTS.primaryFont};
    font-size: 13px;
    span {
        color: ${COLORS.mlbWhite};
        font-weight: 700;
    }
`;

const NameWrapper = styled.div`
    margin-left: 7px;
`;

const A = styled(Link)`
    font-size: 15px;
    font-family: ${FONTS.primaryFont};
    font-weight: 700;
    body & {
        color: ${COLORS.mlbWhite};
        &:hover {
            color: ${COLORS.mlbWhite};
        }
    }
`;

const Hand = styled.div`
    color: ${COLORS.mlbGrey3};
    text-transform: uppercase;
`;

const PlayerInfo = ({
    label,
    player,
    searchRoute,
    stats,
    teamTriCode,
    onPlayerClick,
}) => {

    const {
        id,
        name,
        lastName,
        playerHand,
    } = player;

    const clickHandler = () => {

        Tracking.trackPlayerMatchupPlayerLinkClick();
        if(onPlayerClick) {

            onPlayerClick();

        }

    };


    return (
        <Wrapper>
            <Info>
                <Headshot
                    backgroundColor={`${COLORS.mlbGrey3}`}
                    border={`solid 1px ${COLORS.mlbGrey5}`}
                    height={'52px'}
                    playerId={id}
                    rounded={true}
                    width={'52px'}
                />
                <NameWrapper>
                    <Label>{label} <span>{teamTriCode}</span></Label>
                    <A
                        to={{
                            pathname: searchRoute,
                            search: `?q=${encodeURIComponent(`Player = ["${name}"] Order by Timestamp DESC`)}`,
                        }}
                        onClick={clickHandler}
                    >{lastName}</A>
                    <Hand>{playerHand}</Hand>
                </NameWrapper>
            </Info>
            {stats}
        </Wrapper>
    );

};

PlayerInfo.propTypes = {
    label: PropTypes.string.isRequired,
    player: PropTypes.object.isRequired,
    searchRoute: PropTypes.string,
    stats: PropTypes.element,
    teamTriCode: PropTypes.string.isRequired,
    onPlayerClick: PropTypes.func,
};

PlayerInfo.defaultProps = {
    searchRoute: '/search',
    stats: undefined,
    onPlayerClick: _noop,
};

export default PlayerInfo;
